<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-foreword element-with-heading" id="foreword">
<div class="heading heading-with-title heading-without-image" id="foreword-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Foreword</h1>
</div>
</div>
</div>
</div>
<div class="text" id="foreword-text">
<p class="first first-in-chapter first-full-width">The author takes no responsibility for the validity of factual research conducted during the writing of this book. Please note that there is no insinuation that the British or Chinese Governments and their officers, nor the Financial Conduct Authority, the National Health Service, its employees or agents, are in any way, or have ever been, corrupt. There is no deliberate intention to relate Chinese or British criminality to the pharmaceutical industry or to politics except for solely creative purposes. References whether fact or fiction are only used to add corporate authenticity within the book around the subjects covered and there is no insinuation that individuals or entities mentioned are, or ever have been, involved in any political or commercial corruption. Immerzest Pharmaceuticals and Cellizon are entirely fictional entities with no reference to any existing or previous organisations.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?6b583fc2